import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import jatoLogo from '@/assets/img/jato-logo.png';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    closeMenu();
  };

  return (
    <div className="header-wrapper">
      {/* JATOトップヘッダー (姉妹サイト共通の上部バー) */}
      <div className="jato-top-header">
        <div className="container">
          <div className="jato-logo-area">
            <a href="https://www.jato.co.jp/" target="_blank" rel="noopener noreferrer">
              <img src={jatoLogo} alt="JATO ジャトー株式会社" className="jato-header-logo" />
            </a>
          </div>
          <div className="jato-links">
            <a href="https://wicanvas.jato-prod.com/" target="_blank" rel="noopener noreferrer">
              超薄型ディスプレイ
            </a>
          </div>
        </div>
      </div>

      <header className={`header ${isMenuOpen ? 'menu-open' : ''}`}>
        <nav className="nav">
          <div className="nav-brand">
            <Link to="/" className="logo-link" onClick={scrollToTop}>
              <h1 className="logo">WiCanvas</h1>
            </Link>
          </div>
          
          <button className="mobile-menu-toggle" onClick={toggleMenu} aria-label="メニューを開閉">
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>

          <div className={`nav-menu-container ${isMenuOpen ? 'active' : ''}`}>
            <ul className="nav-menu">
              <li><a href="/#features" onClick={closeMenu}>特長</a></li>
              <li><a href="/#lineup" onClick={closeMenu}>ラインナップ</a></li>
              <li><Link to="/cms-features" onClick={closeMenu}>CMS機能</Link></li>
              <li><a href="/#videos" onClick={closeMenu}>動画</a></li>
              <li>
                <Link to="/download-guide" onClick={closeMenu}>
                  ダウンロード
                </Link>
              </li>
              <li><a href="/#contact" onClick={closeMenu}>お問い合わせ</a></li>
            </ul>
            <div className="nav-mobile-actions">
              <a href="/#contact" className="btn btn-primary" onClick={closeMenu}>お問い合わせ</a>
            </div>
          </div>

          <div className="nav-actions desktop-only">
            <a href="/#contact" className="btn btn-primary">お問い合わせ</a>
          </div>
        </nav>
      </header>
    </div>
  );
};
